import { GET_CUSTOMERS, GET_CUSTOMER_BY_ID, OPEN_ADD_CUSTOMER_MODAL, SORT_CUSTOMERS, RETRIEVE_CREDIT_RECORDS, TOPUP_CREDIT, GET_CREDIT_REPORT, EXPORT_CUSTOMERS_REPORT, EXPORT_CREDIT_REPORT } from '../actions/types';
import _ from 'lodash';

const INITIAL_STATE = {
    list: [],
    selectedCustomer: {
        name: '',
        email: '',
        phone: '',
        address: {
            address_1: '',
            address_2: '',
            postcode: '',
            town_city: '',
            state: '',
            country: ''
        },
        balance: {
            value: 0.0
        }
    },
    creditRecords: null,
    creditReport: null,
    sortColumn: 'name',
    sortDirection: 'ascending',
    customerModalOpen: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMERS:
            console.log(action.payload);

            return {
                ...state,
                list: action.payload,
                customerModalOpen: false
            }

        case GET_CUSTOMER_BY_ID:
            let customer = state.list.find((customer) => customer._id === action.payload);
            return {
                ...state,
                selectedCustomer: customer,
                customerModalOpen: true
            }

        case OPEN_ADD_CUSTOMER_MODAL:
            return {
                ...state,
                selectedCustomer: {
                    name: '',
                    email: '',
                    phone: '',
                    address: {
                        address_1: '',
                        address_2: '',
                        postcode: '',
                        town_city: '',
                        state: '',
                        country: ''
                    },
                    balance: {
                        value: 0.0
                    }
                },
                customerModalOpen: action.payload
            }

        case SORT_CUSTOMERS:
            let sorted = null;
            let sort_column = action.payload;
            let direction = 'ascending';
            if (state.sortColumn !== sort_column) {
                console.log('Sorting by ' + sort_column);
                sorted = _.sortBy(state.list, [sort_column]);
            } else {
                sorted = state.list.reverse();
                console.log(sorted);
                direction = (state.sortDirection === 'ascending') ? 'descending' : 'ascending';
                console.log('Sorting in ' + direction);
            }

            return {
                ...state,
                list: sorted,
                sortColumn: sort_column,
                sortDirection: direction
            }

        case RETRIEVE_CREDIT_RECORDS:
            return {
                ...state,
                creditRecords: action.payload
            }

        case TOPUP_CREDIT:
            return {
                ...state,
                creditRecords: action.payload.records,
                list: action.payload.customers,
                selectedCustomer: action.payload.customers.find((customer) => customer.email === state.selectedCustomer.email)
            }

        case GET_CREDIT_REPORT:
            return {
                ...state,
                creditReport: action.payload
            }

        case EXPORT_CUSTOMERS_REPORT:
            return {
                ...state,
                exportModal: action.payload
            }
        case EXPORT_CREDIT_REPORT:
            return {
                ...state,
                creditReportModal: action.payload
            }

        default:
            return state;
    }
}